// extracted by mini-css-extract-plugin
module.exports = {"termsAndConditionsLink":"TermsAndConditionsLink_termsAndConditionsLink__QzC5x","mobile":"TermsAndConditionsLink_mobile__TWOIw"};